import {useRef, useState} from "react";

import {SearchFormValuesType} from "../types/SearchFormValuesType";

interface IProps {
    formValues: SearchFormValuesType;
}
const useMobileFilters = (props: IProps) => {
    const [isMobileFiltersActive, setMobileFiltersActive] = useState(false);
    const prevFilterState = useRef<{rooms: unknown; price: unknown; area: unknown; floor_choices: unknown; construction_end_date: unknown} | null>(null);

    const toggleMobileFilterModal = () => {
        setMobileFiltersActive((prev) => {
            if (!prev) {
                prevFilterState.current = {
                    rooms: props.formValues.rooms,
                    price: props.formValues.price,
                    area: props.formValues.area,
                    floor_choices: props.formValues.floor_choices,
                    construction_end_date: props.formValues.construction_end_date
                };
            }
            return !prev;
        });
    };

    const closeMobileFilterModal = () => {
        setMobileFiltersActive(false);
        prevFilterState.current = null;
    };

    return {
        isMobileFiltersActive,
        toggleMobileFilterModal,
        closeMobileFilterModal,
        prevFilterState
    };
};

export default useMobileFilters;
import {useRef, useState} from "react";

import {SearchFormValuesType} from "../types/SearchFormValuesType";

interface IProps {
    formValues: SearchFormValuesType;
}
const useMobileFilters = (props: IProps) => {
    const [isMobileFiltersActive, setMobileFiltersActive] = useState(false);
    const prevFilterState = useRef<{rooms: unknown; price: unknown; area: unknown; floor_choices: unknown; construction_end_date: unknown} | null>(null);

    const toggleMobileFilterModal = () => {
        setMobileFiltersActive((prev) => {
            if (!prev) {
                prevFilterState.current = {
                    rooms: props.formValues.rooms,
                    price: props.formValues.price,
                    area: props.formValues.area,
                    floor_choices: props.formValues.floor_choices,
                    construction_end_date: props.formValues.construction_end_date
                };
            }
            return !prev;
        });
    };

    const closeMobileFilterModal = () => {
        setMobileFiltersActive(false);
        prevFilterState.current = null;
    };

    return {
        isMobileFiltersActive,
        toggleMobileFilterModal,
        closeMobileFilterModal,
        prevFilterState
    };
};

export default useMobileFilters;
